/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RadarPortfolioSnapshotResponse = {
    portfolio_id: string;
    portfolio_name: string;
    status: RadarPortfolioSnapshotResponse.status;
};
export namespace RadarPortfolioSnapshotResponse {
    export enum status {
        PUBLISHED = 'published',
        DEPRECATED = 'deprecated',
    }
}

